















import theme from '@zk/theme/lib/variables.scss';
import { defineComponent, toRef, computed } from '@vue/composition-api';
import TheLayoutArea from './TheLayoutArea.vue';

import { useFieldLayout } from '../store';

export default defineComponent({
  name: 'TheLeftArea',
  components: {
    TheLayoutArea
  },
  props: {},
  setup() {
    const store = useFieldLayout();

    // 检验字段是否可以拖入左侧（放开所有字段类型均可拖入左侧）
    const dragPutInspection = () => {
      if (!store.dragTargetCode) {
        return false;
      }
      return true;
    };

    const isHighlight = computed(() => store.isDragging && dragPutInspection());

    return {
      fields: toRef(store, 'leftAreaFields'),
      isHighlight,
      dragPutInspection
    };
  },
  data() {
    return {
      bemNS: theme.bemNS
    };
  }
});
